const ImportIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      id="IMPORT"
      height="100%"
      width="100%"
      viewBox="0 0 28 26.156"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_5540"
            data-name="Rectangle 5540"
            height="100%"
            width="100%"
            fill="none"
          />
        </clipPath>
      </defs>
      <g id="Group_9451" data-name="Group 9451" opacity="0.3">
        <g id="Group_9450" data-name="Group 9450" clipPath="url(#clip-path)">
          <path
            id="Path_12177"
            data-name="Path 12177"
            d="M49.041,30.16l-7.753-7.7c-.277-.275-.683-.026-.683.418V26.29a.487.487,0,0,1-.422.532H32.916a.486.486,0,0,0-.422.531v6.357a.486.486,0,0,0,.422.531h7.267a.486.486,0,0,1,.422.531v3.417c0,.442.4.691.681.419L49.039,31a.622.622,0,0,0,0-.836"
            transform="translate(-21.202 -12.567)"
          />
          <path
            id="Path_12178"
            data-name="Path 12178"
            d="M.161,7.812,7.914.115C8.191-.16,8.6.089,8.6.533V3.942a.487.487,0,0,0,.422.532h7.267a.486.486,0,0,1,.422.531v6.357a.486.486,0,0,1-.422.531H9.019a.486.486,0,0,0-.422.531v3.417c0,.442-.4.692-.681.419L.163,8.649a.622.622,0,0,1,0-.836"
            transform="translate(0 0)"
          />
        </g>
      </g>
    </svg>
  )
}

export default ImportIcon
